import React, { ReactNode, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import '../pages/MainLayout.css';

interface PublicLayoutProps {
    children: ReactNode;
}

interface CompanySettings {
    legal_name?: string;
    trade_name?: string;
    logo?: string | null;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
    const [companySettings, setCompanySettings] = useState<CompanySettings>({});

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/api/public/company/`);
                setCompanySettings(res.data);
            } catch (err) {
                console.error('Error fetching company settings:', err);
            }
        };
        fetchSettings();
    }, []);

    const displayName = companySettings.legal_name || companySettings.trade_name || 'Y-AGENDA';

    return (
        <div className="main-layout-container public-layout-container">
            <header className="public-header text-center">
                {companySettings.logo && (
                    <img 
                        src={companySettings.logo} 
                        alt={companySettings.trade_name || 'Logo'} 
                        style={{ maxHeight: '60px', objectFit: 'contain', marginBottom: '0.5rem' }}
                    />
                )}
                <h1 style={{ letterSpacing: '0.15em', fontSize: '1.25rem', fontWeight: 800 }}>
                    {displayName}
                </h1>
            </header>
            <main className="public-content">
                {children}
            </main>
            <footer className="public-footer">
                &copy; {new Date().getFullYear()} {displayName}
            </footer>
        </div>
    );
};

export default PublicLayout;
